var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDiamonds = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122 191",
    style: {
      enableBackground: "new 0 0 122 191"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "two_three"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "61,33.1 54,42.9 61,52.7 68,42.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61,137.1 54,146.9 61,156.7 68,146.9  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "three_nine_five_nine"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "61,84.7 54,94.5 61,104.3 68,94.5  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "four_five_six_seven_eight_nine_ten"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "46.3,33.9 39.3,43.7 46.3,53.5 53.3,43.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.3,137.9 39.3,147.7 46.3,157.5 53.3,147.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.3,137.9 68.3,147.7 75.3,157.5 82.3,147.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.3,33.9 68.3,43.7 75.3,53.5 82.3,43.7  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "seven"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "61,59.9 54,69.7 61,79.5 68,69.7  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "eight"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "61,110.9 54,120.7 61,130.5 68,120.7  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "six_seven_eight"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "46.5,85.9 39.5,95.7 46.5,105.5 53.5,95.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.5,85.9 68.5,95.7 75.5,105.5 82.5,95.7  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "nine_ten"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "46.2,68.1 39.2,77.9 46.2,87.7 53.2,77.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.2,68.1 68.2,77.9 75.2,87.7 82.2,77.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.2,103.1 68.2,112.9 75.2,122.7 82.2,112.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.2,103.1 39.2,112.9 46.2,122.7 53.2,112.9  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "ten"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "61.2,51.1 54.2,60.9 61.2,70.7 68.2,60.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.2,120.1 54.2,129.9 61.2,139.7 68.2,129.9  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 122,
    height: 191
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20,46.8 10,60.8 20,74.8 30,60.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102,116.8 92,130.8 102,144.8 112,130.8  "
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "ace"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8,114.8c1.7-1.4,2.9-3,3-4.5c-0.9,0.5-2.1,0.9-3.4,1c-0.9-4.2-3.1-9-6.6-14.1c6.4,0.5,12.8,3.1,18.7,7.5l6.6-9.2 L61,67.4L40.9,95.5l19.3,27C62.1,120.5,62.9,117.8,62.8,114.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 -57.1192 109.4036)",
    cx: 66.2,
    cy: 104.2,
    rx: 0.7,
    ry: 1.1
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDiamonds, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/diamonds.0419148e.svg";
export { ForwardRef as ReactComponent };